<template>
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    @click="$emit('click')"
  >
    <path
      d="M3.26778 7.06211L15.2078 2.79461C15.3474 2.72913 15.5038 2.70828 15.6557 2.73488C15.8076 2.76149 15.9476 2.83427 16.0566 2.9433C16.1656 3.05234 16.2384 3.19233 16.265 3.34422C16.2916 3.49611 16.2708 3.6525 16.2053 3.79211L11.9378 15.7321C11.9 15.8978 11.8071 16.0458 11.6742 16.1518C11.5414 16.2577 11.3765 16.3155 11.2065 16.3155C11.0366 16.3155 10.8717 16.2577 10.7388 16.1518C10.606 16.0458 10.513 15.8978 10.4753 15.7321L8.59278 10.8421C8.55536 10.7387 8.49564 10.6448 8.41788 10.567C8.34011 10.4892 8.24619 10.4295 8.14278 10.3921L3.25278 8.52461C3.08744 8.48518 2.9404 8.39076 2.83575 8.25681C2.7311 8.12287 2.67505 7.95735 2.6768 7.78738C2.67854 7.61741 2.73797 7.45307 2.84534 7.3213C2.95272 7.18953 3.10167 7.09814 3.26778 7.06211Z"
      fill="#082655"
    />
    <path
      d="M8.46528 10.5346L10.7153 8.28461M3.26778 7.06211L15.2078 2.79461C15.3474 2.72913 15.5038 2.70828 15.6557 2.73488C15.8076 2.76149 15.9476 2.83427 16.0566 2.9433C16.1656 3.05234 16.2384 3.19233 16.265 3.34422C16.2916 3.49611 16.2708 3.6525 16.2053 3.79211L11.9378 15.7321C11.9 15.8978 11.8071 16.0458 11.6742 16.1518C11.5414 16.2577 11.3765 16.3155 11.2065 16.3155C11.0366 16.3155 10.8717 16.2577 10.7388 16.1518C10.606 16.0458 10.513 15.8978 10.4753 15.7321L8.59278 10.8421C8.55536 10.7387 8.49564 10.6448 8.41788 10.567C8.34011 10.4892 8.24619 10.4295 8.14278 10.3921L3.25278 8.52461C3.08744 8.48518 2.9404 8.39076 2.83575 8.25681C2.7311 8.12287 2.67505 7.95735 2.6768 7.78738C2.67854 7.61741 2.73797 7.45307 2.84534 7.3213C2.95272 7.18953 3.10167 7.09814 3.26778 7.06211V7.06211Z"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'BlueSendIcon19'
};
</script>

<style scoped>

</style>